// extracted by mini-css-extract-plugin
module.exports = {"attendeeMoreMenu":"AttendeeBtnsMore_attendeeMoreMenu__NJ3dJ","menuItem":"AttendeeBtnsMore_menuItem__1PXSS"};